/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AuditRetentionUpdateRequestRetentionPeriodInDays = typeof AuditRetentionUpdateRequestRetentionPeriodInDays[keyof typeof AuditRetentionUpdateRequestRetentionPeriodInDays];


export const AuditRetentionUpdateRequestRetentionPeriodInDays = {
  NUMBER_30: 30,
  NUMBER_365: 365,
} as const;
